import { render, staticRenderFns } from "./sumologic.vue?vue&type=template&id=9150d16e&"
import script from "./sumologic.vue?vue&type=script&lang=js&"
export * from "./sumologic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports